// HeaderContainer.tsx
import React, { useState } from "react";
import NavHeader from "./NavHeader.comp";
import StorefrontMenuSlider from "./storefrontMenuSlider.comp";
import SearchBar from "./Search.comp";

interface HeaderContainerProps {
  onMobileMenuToggle: (isOpen: boolean) => void;
}

export default function HeaderContainer() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // onMobileMenuToggle(!isMobileMenuOpen);
  };

  return (
    <div className="w-full bg-white hidden md:block">
      <div className="max-w-5xl mx-auto px-4">
        <div className="py-2">
          <NavHeader SearchBar={<SearchBar menuOpen={isMobileMenuOpen} />} onMobileMenuToggle={handleMenuToggle} />
        </div>

        {/* Category Slider */}
        <div className="py-2">
          <StorefrontMenuSlider />
        </div>
      </div>
    </div>
  );
}
